import i18n from "@plugins/i18n";
import Modal from "@plugins/modal";
import { ATTEMPTABLE_TYPE } from "@modules/attempt/service/attempt.constant";

const showRecommendedTime = (question) => {
  // show reccomendedTime only when set
  return question.recommendedTime > 0;
};

export const getAttemptErrorCode = (error: unknown): string => {
  if (typeof error === "string") {
    return error;
  }

  if (Array.isArray(error)) {
    return typeof error[0] === "string" ? error[0] : "";
  }

  if (typeof error === "object" && error !== null && "errorMap" in error) {
    const { errorMap } = error as { errorMap?: Record<string, unknown> };
    return typeof errorMap?.["0"] === "string" ? errorMap["0"] : "";
  }

  return "";
};

// only assignment attempts populate metaData; other attempts (e.g. My Drive) attach the lesson, as calendar.task.mixin does
export const getPlannerTaskResource = <M, L>(
  attemptableType: string,
  metaData: M,
  lesson: L,
): M | L => {
  return attemptableType === ATTEMPTABLE_TYPE.ASSIGNMENT_LESSON ? metaData : lesson;
};

const showAssignmentPausedErrorModal = () => {
  return new Promise((resolve) => {
    const props = {
      title: i18n.t("assignment_paused_error_title"),
      content: i18n.t("assignment_paused_error_message"),
      primaryBtnLabel: i18n.t("button_assignment_ok"),
      use_secondaryButton: false,
      actionPrimary: () => resolve(),
      actionHideRequest: () => resolve(),
    };
    Modal.$modal.showMessage("warning", props);
  });
};

export default {
  showRecommendedTime,
  showAssignmentPausedErrorModal,
};
